// src/App.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import MobileOptimizationProvider from './context/MobileOptimizationProvider';
// Importamos los componentes de protección de rutas
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import FeatureFlagRoute from './components/FeatureFlagRoute'; // 🎓 TICKET NVDLP4
import VisualWrapper from './components/VisualWrapper';
import DashboardLayout from './components/DashboardLayout';
import CourseCompletionHelper from './components/CourseCompletionHelper'; // 🎓 TICKET JPRXH6

// Páginas
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyAccount from './pages/VerifyAccount';
import Dashboard from './pages/Dashboard';
import DashboardContent from './pages/DashboardContent';
import ChatPMFAST from './pages/ChatPMFAST';
import NotFound from './pages/NotFound';
import GonePage from './components/GonePage'; // SEO Auditoría Marzo 2026

// Componentes de utilidad
import RedirectRoute from './components/RedirectRoute';
import MobileAdaptiveComponent from './components/MobileAdaptiveComponent';

// 🎓 TICKET KQXTR7 - Rutas paralelas de cursos (Beta)
import CoursesDashboardPage from './pages/CoursesDashboardPage';
import CourseDetailPage from './pages/CourseDetailPage';
import CourseResourcePage from './pages/CourseResourcePage'; // 🎓 TICKET RVDPQ5
import CourseAnalyticsPage from './pages/CourseAnalyticsPage'; // 🎓 TICKET GHTVN9
import CourseBuilderListPage from './pages/admin/CourseBuilderListPage'; // 🎓 TICKET LTPKD7
import CourseBuilderEditPage from './pages/admin/CourseBuilderEditPage'; // 🎓 TICKET QWZMN4
import GroupCourseBuilderListPage from './pages/admin/GroupCourseBuilderListPage'; // 📚 SPRINT 1 - GroupCourse Builder List
import GroupCourseBuilderEditPage from './pages/admin/GroupCourseBuilderEditPage'; // 📚 SPRINT 1 - GroupCourse Builder Edit
import GroupCoursePreviewPage from './pages/admin/GroupCoursePreviewPage'; // 📚 SPRINT 3 - GroupCourse Preview
import DashboardCursosDisponibles from './pages/DashboardCursosDisponibles'; // 📚 SPRINT 4 - GroupCourse Student Catalog
import GroupCourseDetailPage from './pages/GroupCourseDetailPage'; // 📚 SPRINT 4 - GroupCourse Detail Page
// 🚀 STUDENT EXECUTION SYSTEM - Sprint 1 MVP
import StudentCourseWorkspacePage from './pages/StudentCourseWorkspacePage';
import StudentWeekExecutionPage from './pages/StudentWeekExecutionPage';
// 🚀 STUDENT EXECUTION SYSTEM - Sprint 2 Teacher Console
import TeacherMonitorWeekPage from './pages/TeacherMonitorWeekPage';
import TeacherSectionSettingsPage from './pages/TeacherSectionSettingsPage';
import { useAuth } from './context/AuthContext'; // 🎓 TICKET NVDLP4
import InnovaFast from './pages/InnovaFast';
import ReporteAvance from './pages/ReporteAvance';
import ChatPage from './pages/ChatPage';
import Recursos from './pages/Recursos';
import RecursosHub from './pages/RecursosHub';
import RecursosAgenticAI from './pages/RecursosAgenticAI';
import SimuladorDecision from './pages/SimuladorDecision';
import Analytics from './components/Analytics';
import AdminConfig from './pages/AdminConfig';

// InnovaTech Components
import InnovaTechHome from './pages/epl/innovatech/InnovaTechHome';
import LabStepper from './pages/epl/innovatech/LabStepper';
import TeamSelector from './pages/epl/innovatech/TeamSelector';

// 🆕 Nuevo componente limpio para Lab1
import InnovaTechLab1 from './pages/InnovaTechLab1';

// 🧪 Página de pruebas para validar todos los roles IA
import AIRolesTestPage from './pages/AIRolesTestPage';

// 🚀 EPL Lab Builder Components
import { 
  EplBuilderHome, 
  EplLabWizard,
  EplLabRunner,
  EplSessionRunner,
  EplPublicLabs
} from './epl_modules';

// 🔐 EPL Admin Portal Components
import AdminLayout from './epl_modules/layouts/AdminLayout';
import AdminDashboard from './epl_modules/pages/admin/AdminDashboard';
import AdminUsers from './epl_modules/pages/admin/AdminUsers';
import AdminResults from './epl_modules/pages/admin/AdminResults';
import AdminAIAnalytics from './epl_modules/pages/admin/AdminAIAnalytics';
import { 
  AdminReports, 
  AdminSettings, 
  AdminAudit 
} from './epl_modules/pages/admin/AdminPlaceholders';
import StudentMessages from './epl_modules/pages/StudentMessages';
import TeacherMessagesSent from './epl_modules/pages/TeacherMessagesSent';
import CourseFeedbackDashboard from './pages/admin/CourseFeedbackDashboard'; // 💬 Dashboard de feedback

// 🚀 Vertex Quick - Agentes IA rápidos
import VertexSimulator from './pages/vertex/VertexSimulator';
import VertexLabPage from './pages/vertex/VertexLabPage';
import VertexBuilder from './pages/vertex/VertexBuilder';
import AgentEditor from './pages/vertex/AgentEditor';
import ComposerView from './pages/vertex/ComposerView';
import VertexAnalytics from './pages/vertex/VertexAnalytics';
import SessionDetail from './pages/vertex/SessionDetail';
import SessionsAnalyticsDashboard from './components/SessionsAnalyticsDashboard';

// � TICKET 482731Q - Micro-Programas Ejecutivos (Público)
import ProgramsIndex from './pages/programs/ProgramsIndex';// 🏅 BADGE SYSTEM - Página pública de verificación de insignia
import BadgePage from './pages/BadgePage';
// 🏅 BADGE SYSTEM - Páginas privadas de certificados
import CertificatesPage from './pages/certificates/CertificatesPage';
import CertificateDetailPage from './pages/certificates/CertificateDetailPage';import ProgramLanding from './pages/programs/ProgramLanding';
import UnitPage from './pages/programs/UnitPage';
import UnitTest from './pages/programs/UnitTest';
// 📝 Blog - Sistema de contenido educativo
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
// 🏗️ Colecciones - Hub editorial
import ColeccionesIndex from './pages/ColeccionesIndex';
import ColeccionADO from './pages/ColeccionADO';
import ColeccionADOArticle from './pages/ColeccionADOArticle';
import ColeccionADOConceptos from './pages/ColeccionADOConceptos';
import ColeccionADOConcepto from './pages/ColeccionADOConcepto';
import SevenAmLibrary from './pages/SevenAmLibrary';
import SevenAmLibraryEp0 from './pages/SevenAmLibraryEp0';
import SevenAmLibraryEp1 from './pages/SevenAmLibraryEp1';
import SevenAmLibraryEp2 from './pages/SevenAmLibraryEp2';
import SimuladorB2B from './pages/SimuladorB2B';
// 👥 GROUP SYSTEM - Sistema de cursos grupales
import SectionManager from './pages/SectionManager';
import GroupManager from './pages/GroupManager';
import WeeklyDeliverableEditor from './pages/WeeklyDeliverableEditor';
import CrossFeedbackPanel from './pages/CrossFeedbackPanel';
import GroupDashboard from './pages/GroupDashboard';
import HomeDashboard from './pages/HomeDashboard';
import MobileBestPracticesDemo from './pages/MobileBestPracticesDemo';// �🎓 TICKET NVDLP4 - Wrapper interno para acceder a useAuth
const AppRoutes = ({ sidebarVisible, setSidebarVisible, handleLogout }) => {
  const { user } = useAuth();
  
  // Feature flags separados
  // Micro Cursos: Solo admin/teacher o con flag específico
  const microCoursesEnabled = user?.role === 'admin' || user?.role === 'teacher' || Boolean(user?.flags?.courses_v1);
  
  // Programas Grupales: Disponibles para TODOS los usuarios autenticados
  const groupCoursesEnabled = Boolean(user);

  return (
    <Routes>
          {/* ✅ RUTAS PÚBLICAS */}
          <Route path='/' element={<Home />} />
          <Route path='/login' element={<Login />} />
          
          {/* 🔄 REDIRECTS - Rutas obsoletas → /login (301 permanent) */}
          <Route path='/registro' element={<RedirectRoute to="/login" />} />
          <Route path='/register' element={<RedirectRoute to="/login" />} />
          
          <Route path='/verificar' element={<VerifyAccount />} />
          
          {/* 🎵 TICKET 482731Q - Micro-Programas Ejecutivos (Público - Sin autenticación) */}
          <Route path='/programas' element={<ProgramsIndex />} />
          <Route path='/p/:programSlug' element={<ProgramLanding />} />
          <Route path='/p/:programSlug/u/:unitSlug' element={<UnitPage />} />
          <Route path='/p/:programSlug/u/:unitSlug/test' element={<UnitTest />} />
          {/* 🏅 BADGE - Verificación pública de insignia (Sin autenticación) */}
          <Route path='/badge/:verificationId' element={<BadgePage />} />
          {/* 📝 Blog - Sistema de contenido educativo (Público - Sin autenticación) */}
          <Route path='/blog' element={<BlogIndex />} />
          <Route path='/blog/:slug' element={<BlogPost />} />
          {/* 🏗️ Colecciones - Hub editorial (Público) */}
          <Route path='/colecciones' element={<ColeccionesIndex />} />
          <Route path='/colecciones/ado' element={<ColeccionADO />} />
          <Route path='/colecciones/ado/conceptos' element={<ColeccionADOConceptos />} />
          <Route path='/colecciones/ado/conceptos/:conceptoSlug' element={<ColeccionADOConcepto />} />
          <Route path='/colecciones/ado/:articleSlug' element={<ColeccionADOArticle />} />
          {/* 7AM Library — Biblioteca de audios educativos (Público) */}
          <Route path='/7am-library' element={<SevenAmLibrary />} />
          <Route path='/7am-library/episodio-0' element={<SevenAmLibraryEp0 />} />
          <Route path='/7am-library/episodio-1' element={<SevenAmLibraryEp1 />} />
          <Route path='/7am-library/episodio-2' element={<SevenAmLibraryEp2 />} />
          <Route path='/simulador-b2b' element={<SimuladorB2B />} />
          {/* 🔐 RUTAS PRIVADAS */}

          {/* 🏠 HOME — Landing post-login para todos los usuarios */}
          <Route path='/home' element={
            <PrivateRoute>
              <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                <HomeDashboard />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🏅 CERTIFICADOS — Lista y detalle de insignias del usuario */}
          <Route path='/home/certificates' element={
            <PrivateRoute>
              <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                <CertificatesPage />
              </DashboardLayout>
            </PrivateRoute>
          } />
          <Route path='/home/certificates/:verificationId' element={
            <PrivateRoute>
              <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                <CertificateDetailPage />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🛡️ DASHBOARD — Solo admin/teacher */}
          <Route path='/dashboard' element={
            <PrivateRoute>
              <Dashboard sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible} />
            </PrivateRoute>
          } />

          {/* TICKET KQXTR7/NVDLP4 - Cursos (Beta) - Micro-Cursos del Course Lab Builder */}
          <Route path='/dashboard_cursos_disponibles' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={microCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <CoursesDashboardPage />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>
          } />

          {/* Programas - Cursos Grupales de 18 Semanas */}
          <Route path='/cursos-grupales' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={groupCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <DashboardCursosDisponibles />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>
          } />

          {/* SPRINT 4 - Detalle de Curso Grupal */}
          <Route path='/group-courses/:courseId' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={groupCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <GroupCourseDetailPage />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>
          } />

          {/* 🚀 STUDENT EXECUTION SYSTEM - Sprint 1 MVP */}
          {/* Workspace del Curso - Capa 2 del Student Execution System */}
          <Route path='/course/:sectionId/workspace' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={groupCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <StudentCourseWorkspacePage />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>
          } />

          {/* Vista de Ejecución Semanal - Capa 3 del Student Execution System */}
          <Route path='/course/:sectionId/week/:weekNumber' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={groupCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <StudentWeekExecutionPage />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>  
          } />

          {/* 🚀 STUDENT EXECUTION SYSTEM - Sprint 2 Teacher Console */}
          {/* Configuración de Sección - Docente */}
          <Route path='/teacher/:sectionId/settings' element={
            <PrivateRoute>
              <AdminRoute>
                <FeatureFlagRoute enabled={groupCoursesEnabled} fallbackPath="/dashboard">
                  <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                    <TeacherSectionSettingsPage />
                  </DashboardLayout>
                </FeatureFlagRoute>
              </AdminRoute>
            </PrivateRoute>
          } />

          {/* Monitor de Semana Específica - Consola Docente */}
          <Route path='/teacher/:sectionId/week/:weekNumber' element={
            <PrivateRoute>
              <AdminRoute>
                <FeatureFlagRoute enabled={groupCoursesEnabled} fallbackPath="/dashboard">
                  <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                    <TeacherMonitorWeekPage />
                  </DashboardLayout>
                </FeatureFlagRoute>
              </AdminRoute>
            </PrivateRoute>
          } />

          {/* TICKET RVDPQ5 - Vista de recurso embebido (YouTube) */}
          <Route path='/courses/:courseId/activity/:activityId' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={microCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <CourseResourcePage />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>
          } />

          <Route path='/courses/:courseId/analytics' element={
            <PrivateRoute>
              <FeatureFlagRoute enabled={microCoursesEnabled} fallbackPath="/dashboard">
                <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
                  <CourseAnalyticsPage />
                </DashboardLayout>
              </FeatureFlagRoute>
            </PrivateRoute>
          } />

          {/* Mantén tus otras rutas aquí */}
          <Route path='/pmfast/chat' element={
            <PrivateRoute>
              <DashboardLayout setSidebarVisible={setSidebarVisible} sidebarVisible={sidebarVisible}>
                <ChatPMFAST />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/innovafast' element={
            <PrivateRoute>
              <DashboardLayout setSidebarVisible={setSidebarVisible} sidebarVisible={sidebarVisible}>
                <InnovaFast />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/dashboard/progreso' element={
            <PrivateRoute>
              <DashboardLayout setSidebarVisible={setSidebarVisible} sidebarVisible={sidebarVisible}>
                <ReporteAvance />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/chat/:assistantId' element={
            <PrivateRoute>
              <DashboardLayout setSidebarVisible={setSidebarVisible} sidebarVisible={sidebarVisible}>
                <ChatPage />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* Hub de recursos — grid de tarjetas */}
          <Route path='/recursos' element={<RecursosHub />} />
          {/* Simulador Lean Startup */}
          <Route path='/recursos/lean-simulador' element={<Recursos />} />
          {/* Demo visual Agentic AI */}
          <Route path='/recursos/agentic-ai' element={<RecursosAgenticAI />} />
          {/* Simulador de Decisión Ejecutiva — Decision Lab */}
          <Route path='/recursos/simulador-decision' element={<SimuladorDecision />} />

          {/* Admin Config - Gestion centralizada de usuarios y sistema */}
          <Route path='/admin/config' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <AdminConfig />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* GROUP SYSTEM - Gestion de Secciones (Teachers/Admins) */}
          <Route path='/teaching/sections' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <SectionManager />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* GROUP SYSTEM - Gestion de Grupos dentro de una Seccion */}
          <Route path='/teaching/sections/:sectionId/groups' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <GroupManager />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 👥 GROUP SYSTEM - Editor de Entregables Semanales Colaborativo */}
          <Route path='/teaching/sections/:sectionId/groups/:groupId/weekly/:week' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <MobileAdaptiveComponent component="WeeklyDeliverableEditor" />
              </DashboardLayout>
            </PrivateRoute>
          } />
          
          {/* 🔄 GROUP SYSTEM - Cross Feedback Panel (Sistema B6) */}
          <Route path='/teaching/sections/:sectionId/groups/:groupId/cross-feedback/:week' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <MobileAdaptiveComponent component="CrossFeedbackPanel" />
              </DashboardLayout>
            </PrivateRoute>
          } />
          
          {/* 📊 TEACHER DASHBOARD - Vista Docente Multi-Grupo */}
          <Route path='/teaching/dashboard' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <MobileAdaptiveComponent component="GroupDashboard" />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🎓 TICKET LTPKD7 - Course Builder Admin */}
          <Route path='/admin/course-builder' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <CourseBuilderListPage />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* 🎓 TICKET QWZMN4 - Course Builder Edit Page */}
          <Route path='/admin/course-builder/:courseId/edit' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <CourseBuilderEditPage />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* 📚 SPRINT 1 - GroupCourse Builder List */}
          <Route path='/admin/group-course-builder' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <GroupCourseBuilderListPage />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* 📚 SPRINT 1 - GroupCourse Builder Edit Page */}
          <Route path='/admin/group-course-builder/:courseId/edit' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <GroupCourseBuilderEditPage />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* 📚 SPRINT 3 - GroupCourse Preview Page */}
          <Route path='/admin/group-course-builder/:courseId/preview' element={
            <AdminRoute>
              <GroupCoursePreviewPage />
            </AdminRoute>
          } />

          {/* � FEEDBACK - Dashboard de feedback de micro-cursos */}
          <Route path='/admin/course-feedback' element={
            <AdminRoute>
              <CourseFeedbackDashboard />
            </AdminRoute>
          } />

          {/* �🚀 InnovaTech Lab Routes */}
          <Route path='/dashboard/innova-tech' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <InnovaTechHome />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/dashboard/innova-tech/lab/:labId' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <LabStepper />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/dashboard/innova-tech/team-selector' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <TeamSelector />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🆕 Ruta limpia para Lab1 - SIN MessageBubble */}
          <Route path='/innovatech-lab1-clean' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <InnovaTechLab1 />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🧪 Ruta de pruebas para validar todos los roles IA */}
          <Route path='/ai-roles-test' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <AIRolesTestPage />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 📱 Demo de Mejores Prácticas Móviles */}
          <Route path='/mobile-demo' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <MobileBestPracticesDemo />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🚀 EPL LAB BUILDER ROUTES */}
          {/* Laboratorios Públicos - TODOS LOS USUARIOS AUTENTICADOS */}
          <Route path='/epl/labs' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplPublicLabs />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* Mensajes del Docente - ESTUDIANTES */}
          <Route path='/epl/messages' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <StudentMessages />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* Mensajes Enviados - DOCENTES/ADMINS */}
          <Route path='/epl/teacher/messages-sent' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <TeacherMessagesSent />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* Laboratorios filtrados por sistema */}
          <Route path='/epl/labs/:systemCard' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplPublicLabs />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* Dashboard Principal EPL - SOLO ADMINS */}
          <Route path='/epl/builder' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplBuilderHome />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* Crear Nuevo Laboratorio - SOLO ADMINS */}
          <Route path='/epl/builder/new' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplLabWizard />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* Editar Laboratorio Existente - SOLO ADMINS */}
          <Route path='/epl/builder/edit/:labId' element={
            <AdminRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplLabWizard />
              </DashboardLayout>
            </AdminRoute>
          } />

          {/* Ejecutar Laboratorio (Estudiantes) */}
          <Route path='/epl/lab/:labId' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplLabRunner />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* Continuar Sesión Activa */}
          <Route path='/epl/session/:sessionId' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <EplSessionRunner />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🔐 EPL ADMIN PORTAL ROUTES */}
          <Route path='/epl/admin' element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route path='dashboard' element={<AdminDashboard />} />
            <Route path='users' element={<AdminUsers />} />
            <Route path='labs' element={<EplBuilderHome />} />
            <Route path='results' element={<AdminResults />} />
            <Route path='ai-analytics' element={<AdminAIAnalytics />} />
            <Route path='reports' element={<AdminReports />} />
            <Route path='settings' element={<AdminSettings />} />
            <Route path='audit' element={<AdminAudit />} />
          </Route>

          {/* 🚀 VERTEX QUICK - Agentes IA con Gemini + RAG */}
          {/* ACCESO RESTRINGIDO: Solo davidprudencio@hotmail.com */}
          <Route path='/vertex/simulator' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <VertexSimulator />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🧪 VERTEX LAB PAGE - Experiencia inmersiva sin DashboardLayout */}
          <Route path='/vertex/lab' element={
            <PrivateRoute>
              <VertexLabPage />
            </PrivateRoute>
          } />

          {/* 📊 VERTEX ANALYTICS - Análisis de Sesiones */}
          <Route path='/vertex/analytics' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <VertexAnalytics />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 📄 VERTEX SESSION DETAIL - Detalle de sesión con evaluación */}
          <Route path='/vertex/session/:sessionId' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <SessionDetail />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 🛠️ VERTEX LAB BUILDER - Constructor visual de agentes */}
          {/* ACCESO RESTRINGIDO: Solo davidprudencio@hotmail.com */}
          <Route path='/vertex/builder' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <VertexBuilder />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 👥 VERTEX ADMIN USERS - REDIRIGIDO a Config Admin */}
          <Route path='/vertex/admin/users' element={
            <Navigate to="/admin/config" replace />
          } />

          {/* 📊 SESSIONS ANALYTICS - Dashboard de observabilidad (Zombie + Normal) */}
          <Route path='/vertex/admin/sessions' element={
            <AdminRoute>
              <SessionsAnalyticsDashboard />
            </AdminRoute>
          } />

          <Route path='/vertex/builder/new' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <AgentEditor mode="new" />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/vertex/builder/edit/:agentId' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <AgentEditor mode="edit" />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/vertex/builder/view/:agentId' element={
            <PrivateRoute>
              <DashboardLayout 
                sidebarVisible={sidebarVisible} 
                setSidebarVisible={setSidebarVisible}
              >
                <AgentEditor mode="view" />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/vertex/builder/composer' element={
            <PrivateRoute>
              <DashboardLayout
                sidebarVisible={sidebarVisible}
                setSidebarVisible={setSidebarVisible}
              >
                <ComposerView />
              </DashboardLayout>
            </PrivateRoute>
          } />

          <Route path='/vertex/builder/composer/:agentId' element={
            <PrivateRoute>
              <DashboardLayout
                sidebarVisible={sidebarVisible}
                setSidebarVisible={setSidebarVisible}
              >
                <ComposerView />
              </DashboardLayout>
            </PrivateRoute>
          } />

          {/* 📊 VERTEX AI ANALYTICS - REDIRIGIDO a Config Admin */}
          <Route path='/vertex/ai-analytics' element={
            <Navigate to="/admin/config" replace />
          } />

          {/* ===================================================== */}
          {/* SEO CLEANUP — Auditoría SEO Marzo 2026                 */}
          {/* Grupo 1: Contenido eliminado → 410 Gone (sem.)         */}
          <Route path='/pmfast' element={<GonePage />} />
          <Route path='/whitepaper' element={<GonePage />} />
          <Route path='/proyectos' element={<GonePage />} />
          <Route path='/contact' element={<GonePage />} />
          {/* Grupo 2: Contenido conceptual → 301 redirect a /blog   */}
          <Route path='/metodologias' element={<RedirectRoute to="/blog" />} />
          {/* Grupo 3: Activo de negocio → embudo principal (301)     */}
          {/* Forzar lowercase: /CoachIA y /coachia → /simulador-b2b */}
          <Route path='/CoachIA' element={<RedirectRoute to="/simulador-b2b" />} />
          <Route path='/coachia' element={<RedirectRoute to="/simulador-b2b" />} />
          {/* ===================================================== */}

          {/* 🚫 CATCH-ALL - Cualquier ruta no definida → 404 */}
          <Route path='*' element={<NotFound />} />

        </Routes>
    );
  };

  function App() {
    const [sidebarVisible, setSidebarVisible] = useState(false);
    
    const handleLogout = () => {
      localStorage.removeItem("token");
      window.location.href = "/login";
    };

    return (
      <AuthProvider>
        <MobileOptimizationProvider>
          <Router>
            <Analytics />
            {/* 🎓 TICKET JPRXH6 - Helper global para marcar actividades completadas */}
            <CourseCompletionHelper />
            <AppRoutes 
              sidebarVisible={sidebarVisible} 
              setSidebarVisible={setSidebarVisible}
              handleLogout={handleLogout}
            />
          </Router>
        </MobileOptimizationProvider>
      </AuthProvider>
    );
  }

export default App;